<template>
    <div class="px-4 full-height">
        <div class="d-flex align-items-center justify-content-between my-4">
            <div class="d-flex align-items-center col-sm-3 pl-0">
                <div class="d-flex w-100">
                    <input class="glued-right bg-lighter w-100" type="text" v-model="searchQuery" placeholder="Search">
                    <div class="glued-left dark pointer">
                        <i class="ico-search larger color-1 search-icon-align"></i>
                    </div>
                </div>
            </div>

            <button class="btn" @click="addRule" v-if="account.accessType === 1">
                <i class="ico ico-add mt-1"></i> Add Rule
            </button>
        </div>

        <div class="d-flex flex-column justify-content-center align-items-center vh-65" v-if="getLoadingRules || loading">
            <span class="dark bold">Loading</span>
            <loader></loader>
        </div>
        <div v-else>
            <list :header="header" :body="body" :rows="filteredResults" :actions="actions"></list>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    import List from '@/tools/list/baseList'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data() {
            return {
                isEdit: false,
                searchQuery: null,
                showInactive: false,
                header: {
                    selection: {
                        active: false,
                    },
                    list: {
                        active: 'Active',
                        name: 'Name',
                        details: 'Details',
                        cancellations: 'Cancellations'
                    },
                    sort: {
                        list: [{ key: 'name', direction: 'asc' }],
                    }
                },
                body: {
                    selection: {
                        active: false,
                    },
                    customCells: {
                        active: this.formatActive,
                        details: this.formatDetails,
                        cancellations: this.formatCancellations,
                    },
                    customClassCell: {
                         active: 'rules-active-row-size'
                    },
                    customRowEvent: this.edit,
                },
                actions: {
                    label : 'Actions',
                    list: [
                        {
                            slug: 'duplicate',
                            title: 'Duplicate',
                            tooltip: 'Duplicate',
                            params: '',
                            class: '',
                            icon: 'fas fa-clone largest',
                            event: this.duplicateRule,
                        },
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.edit,
                        },
                        {
                            slug: 'delete',
                            title: 'Delete',
                            tooltip: 'Delete',
                            params: '',
                            class: '',
                            icon: 'ico-delete largest',
                            event: this.deleteRules,
                        }
                    ],
                },
                ruleMap: {
                    '1-1-3': 'Base Price | Occupation (More then) | Price Increase',
                    '1-2-3': 'Base Price | Occupation (Less then) | Price Increase',
                    '2-1-1': 'Sales Channels | Occupation | Open/Close',
                    '2-1-3': 'Sales Channels | Occupation | Price Increase',
                    '2-4-2': 'Sales Channels | Number of Seats | Closed',
                    '2-3-3': 'Sales Channels | Days of Week | Price Increase',
                    '3-1-3': 'Days of Week | Occupation | Price Increase'
                },
                loading: null,
            }
        },
        computed: {
            ...mapGetters([
               'getRules',
               'getLoadingRules',
               'account'
            ]),
            filteredResults() {
                this.loading = true;

                if (this.searchQuery) {
                    this.loading = false;

                    return this.getRules.filter(category => {
                        return category.name.toLowerCase().includes(this.searchQuery.toLowerCase());
                    })
                } else {
                    this.loading = false;

                    return this.getRules;
                }
            }
        },
        methods:{
            ...mapActions([
                'deleteRule',
                'setSelectedRuleItem',
                'openModal',
                'downloadRules',
                'downloadRulesGroup',
                'startFullScreenLoading',
                'stopFullScreenLoading'
            ]),
            toggleShowInactive(e) {
                this.showInactive = e.value;
            },
            addRule() {
                this.$router.push({ name: 'pluralo.rules.new' });
            },
            duplicateRule(item) {
                this.setSelectedRuleItem({type: 'rules', id: item.id });
                this.openModal('RulesDuplicate');
            },
            edit(item) {
                if (item.id !== undefined) {
                    this.setSelectedRuleItem({ type: 'rules', id: item.id });
                    this.$router.push({ name: 'pluralo.rules.editRule', params: { id: item.id } });
                }
            },
            deleteRules(rule) {
                const finalRule = { ...rule, isDeleted: true };

                this.$dialog.confirm(`
                    <div class="d-flex flex-column justify-content-center">
                        <div class="fs-largest font-weight-600 mb-4">You are about to delete ${rule.hasProductGroupAssossiation ? 'an <span class="color-6"> Active</span> Rule' : 'a Rule'}!</div>
                        <div class="dark mb-4">This action is irreversible and will permanently delete the Rule.</div>
                        <div class="dark">Are you sure you want to proceed?</div>
                    </div>`,
                    { okText: 'Yes', cancelText: 'No' }
                ).then(() => {
                    this.$toasted.info('Deleting', { duration: 2000 });
                    this.startFullScreenLoading();            
                    
                    this.deleteRule(finalRule).then(success => {
                        if (success) {
                            this.$toasted.success('Successfully deleted', { duration: 2000 });
                        } else {
                            this.$toasted.error('An error occurred', { duration: 2000 });
                        }
                        
                        this.downloadRules();
                        this.downloadRulesGroup();
                        this.stopFullScreenLoading();
                    }).catch(error => {
                        this.$toasted.error('An unexpected error occurred', { duration: 2000 });
                        console.error(error);
                        this.stopFullScreenLoading();
                    })
                })
            },
            formatActive(item) {
                return `<div class="rules-active-circle ${item.hasProductGroupAssossiation ? 'active' : 'inactive'}"></div>`;
            },
            formatDetails(item) {
                const key = `${item.targetVariableType}-${item.conditionType}-${item.actionType}`;
                
                return this.ruleMap[key] || 'Not available';
            },
            formatCancellations(item) {
                return item.behaviorOnCancellation === 1 ? 'Revert' : 'Maintain';
            }
        },
        components:{
            Loader,
            List
        }
    }
</script>

<style scoped lang="scss">
    .full-height {
        min-height: 77vh;
    }

    .search-icon-align {
        position: relative;
        left: 4px;
        top: 1px;
    }
    
    .pointer {
        cursor: pointer;
    }

    .vh-65 {
        height: 65vh;
    }
</style>

<style lang="scss">
    .rules-active-circle {
        height: 12px;
        width: 12px;
        display: block;
        border-radius: 52%;
        margin-left: 12px;

        &.active {
             background-color: #6ac951;
        }

        &.inactive {
            background-color: #d4d4d4;
        }
    }

    .rules-active-row-size {
        width: 80px;
    }
</style>



// WEBPACK FOOTER //
// TabRules.vue?824cb384